/* BTTO PDP redesign 2.4.0 – native behaviours (replaces Tabs Studio + Buy Me) */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var mqDesktop = window.matchMedia('(min-width: 1025px)');

  /* ---------- Header height + compact header on scroll ---------- */
  function header() { return doc.querySelector('.shopify-section-group-header-group.sticky-header') || doc.querySelector('#app-header'); }
  function setHeaderVar() {
    var h = header();
    var px = h && getComputedStyle(h).position === 'sticky' ? h.getBoundingClientRect().height : 0;
    root.style.setProperty('--btto-header-h', Math.round(px) + 'px');
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || 0;
      if (y > 120) root.classList.add('btto-scrolled'); else if (y < 40) { root.classList.remove('btto-scrolled'); root.classList.remove('btto-search-open'); }
      setHeaderVar(); ticking = false;
    });
  }
  function addSearchToggle() {
    var upper = doc.querySelector('#app-upper-header .account-session-links') || doc.querySelector('#app-upper-header .column-max');
    if (!upper || doc.querySelector('.btto-search-toggle')) return;
    var b = doc.createElement('button');
    b.type = 'button'; b.className = 'btto-search-toggle'; b.setAttribute('aria-label', 'Search');
    b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"/><path d="M20 20l-4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    b.addEventListener('click', function () {
      root.classList.toggle('btto-search-open');
      var i = doc.querySelector('#app-lower-header input[type="search"], #app-lower-header input[name="q"]');
      if (i && root.classList.contains('btto-search-open')) i.focus();
    });
    upper.insertBefore(b, upper.firstChild);
  }

  /* ---------- Content sections: open on desktop, closed on mobile ---------- */
  function syncSections() {
    doc.querySelectorAll('[data-btto-sec]').forEach(function (d) {
      if (mqDesktop.matches) d.setAttribute('open', ''); else if (!d.dataset.userOpened) d.removeAttribute('open');
    });
  }
  function bindSectionLinks() {
    doc.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#btto-sec-"]');
      if (!a) return;
      var t = doc.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      if (t.tagName === 'DETAILS') { t.setAttribute('open', ''); t.dataset.userOpened = '1'; }
      var top = t.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(root).getPropertyValue('--btto-header-h')) || 0) - 64;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
    doc.querySelectorAll('[data-btto-sec] > summary').forEach(function (s) {
      s.addEventListener('click', function () { s.parentElement.dataset.userOpened = '1'; });
    });
    // highlight active nav link
    var nav = doc.querySelector('[data-btto-section-nav]');
    if (!nav || !('IntersectionObserver' in window)) return;
    var links = {};
    nav.querySelectorAll('a').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && links[en.target.id]) {
          Object.keys(links).forEach(function (k) { links[k].classList.remove('is-active'); });
          links[en.target.id].classList.add('is-active');
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    doc.querySelectorAll('[data-btto-sec]').forEach(function (s) { io.observe(s); });
  }

  /* ---------- Finance panel: move Shop Pay instalments line inside ---------- */
  function finance() {
    var body = doc.querySelector('[data-btto-finance-body]');
    var terms = doc.querySelector('.product-detail .variants .shopify-payment-terms');
    if (body && terms) body.insertBefore(terms, body.firstChild);
  }

  /* ---------- Reviews: move Feefo on-page widget into the Reviews section when it has content ---------- */
  function reviews() {
    var sec = doc.querySelector('[data-btto-reviews]');
    var bodyEl = doc.querySelector('[data-btto-reviews-body]');
    var link = doc.querySelector('[data-btto-reviews-link]');
    var w = doc.querySelector('.feefo-review-widget-product');
    if (!sec || !bodyEl || !w) return;
    var block = w.closest('.shopify-app-block') || w;
    function check() {
      var hasContent = w.offsetHeight > 40 || w.querySelector('[class*="review"] p, [class*="review-item"], li');
      if (hasContent) {
        bodyEl.appendChild(block);
        sec.hidden = false; if (link) link.hidden = false;
        syncSections();
        return true;
      }
      return false;
    }
    if (check()) return;
    var tries = 0;
    var mo = new MutationObserver(function () { if (check() || ++tries > 50) mo.disconnect(); });
    mo.observe(w, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 12000);
  }

  /* ---------- Delivery estimate (working days, UK bank holidays) ---------- */
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function ukNow() {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
      return { date: new Date(+o.year, +o.month - 1, +o.day), hour: +o.hour };
    } catch (e) { var d = new Date(); return { date: new Date(d.getFullYear(), d.getMonth(), d.getDate()), hour: d.getHours() }; }
  }
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function isWorking(d, hol) { var w = d.getDay(); return w !== 0 && w !== 6 && hol.indexOf(iso(d)) === -1; }
  function addWorking(start, n, hol) { var d = new Date(start); var c = 0; while (c < n) { d.setDate(d.getDate() + 1); if (isWorking(d, hol)) c++; } return d; }
  function fmt(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function range(a, b) { return a.getTime() === b.getTime() ? fmt(a) : fmt(a) + ' – ' + fmt(b); }
  function money(cents) { return '£' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function delivery(variant) {
    var el = doc.querySelector('[data-btto-delivery]');
    if (!el) return;
    var ds = el.dataset;
    var available = variant ? variant.available : ds.available === 'true';
    var qty = variant && typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : parseInt(ds.qty, 10);
    var managed = variant ? !!variant.inventory_management : ds.managed === 'true';
    var policy = variant && variant.inventory_policy ? variant.inventory_policy : ds.policy;
    var price = variant ? variant.price : parseInt(ds.price, 10);
    var low = parseInt(ds.low, 10) || 5;
    var stock = el.querySelector('[data-btto-stock]');
    var std = el.querySelector('[data-btto-std]');
    var exp = el.querySelector('[data-btto-exp]');
    var nudge = el.querySelector('.btto-delivery__nudge');
    var threshold = parseInt(ds.threshold, 10);

    var backorder = available && managed && qty <= 0 && policy === 'continue';
    if (stock) {
      if (!available) stock.innerHTML = '<span class="btto-dot btto-dot--grey"></span> Out of stock';
      else if (backorder) stock.innerHTML = '<span class="btto-dot btto-dot--amber"></span> Available to order – longer delivery time';
      else if (managed && qty > 0 && qty <= low) stock.innerHTML = '<span class="btto-dot btto-dot--amber"></span> Only ' + qty + ' left in stock';
      else stock.innerHTML = '<span class="btto-dot btto-dot--green"></span> In stock';
    }
    if (!available) { if (std) std.hidden = true; if (exp) exp.hidden = true; if (nudge) nudge.hidden = true; return; }
    if (std) std.hidden = false; if (exp) exp.hidden = false;

    var hol = (ds.holidays || '').split(',').filter(Boolean);
    var now = ukNow();
    var start = now.date;
    var cutoff = parseInt(ds.cutoff, 10);
    // Orders placed on a non-working day, or after the cut-off, start from the next working day
    if (!isWorking(start, hol) || (!isNaN(cutoff) && cutoff > 0 && now.hour >= cutoff)) {
      var s = new Date(start); do { s.setDate(s.getDate() + 1); } while (!isWorking(s, hol)); start = s;
    }
    var extra = backorder ? 5 : 0;
    var smin = parseInt(ds.stdMin, 10) + extra, smax = parseInt(ds.stdMax, 10) + extra;
    var sd = el.querySelector('[data-btto-std-dates]');
    if (sd && smin > 0) sd.textContent = ' – estimated ' + range(addWorking(start, smin, hol), addWorking(start, smax, hol));
    if (std) {
      var strong = std.querySelector('strong');
      if (strong) strong.textContent = price >= threshold ? 'FREE delivery' : money(parseInt(ds.stdCost, 10)) + ' delivery';
    }
    var ed = el.querySelector('[data-btto-exp-dates]');
    if (ed && ds.exp === 'true' && !backorder) ed.textContent = '– estimated ' + range(addWorking(start, parseInt(ds.expMin, 10), hol), addWorking(start, parseInt(ds.expMax, 10), hol));
    else if (exp) exp.hidden = true;
    if (nudge) { if (price < threshold) { nudge.hidden = false; nudge.textContent = 'Spend ' + money(threshold - price) + ' more for free delivery'; } else nudge.hidden = true; }
  }

  /* ---------- Variant changes ---------- */
  function productJson() {
    var s = doc.querySelector('script[id^="ProductJson-"]');
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  function currentVariant() {
    var p = productJson(); var input = doc.querySelector('.product-detail form[action*="/cart/add"] input[name="id"]');
    if (!p || !input) return null;
    var v = p.variants.filter(function (x) { return String(x.id) === String(input.value); })[0];
    if (!v) return null;
    try {
      var st = window.Station && Station.Theme && Station.Theme.current && Station.Theme.current.product;
      var idx = p.variants.indexOf(v);
      if (st && st.variants && st.variants[idx]) { v.inventory_quantity = st.variants[idx].inventory_quantity; v.inventory_policy = st.variants[idx].inventory_policy; }
    } catch (e) {}
    return v;
  }
  function bindVariants() {
    doc.addEventListener('change', function (e) {
      if (!e.target.closest('.product-detail [data-option-selector], .product-detail .option-selector')) return;
      setTimeout(function () { var v = currentVariant(); if (v) { delivery(v); sticky.update(v); } }, 80);
    });
  }

  /* ---------- Qty stepper ---------- */
  function stepper() {
    var q = doc.querySelector('.product-detail .variants input#quantity');
    if (!q || q.dataset.btto) return; q.dataset.btto = '1';
  }

  /* ---------- Native sticky add-to-basket ---------- */
  var sticky = { el: null, update: function () {} };
  function initSticky() {
    var el = doc.querySelector('[data-btto-sticky]');
    var mainBtn = doc.querySelector('.product-detail .variants .add-to-cart');
    if (!el || !mainBtn) return;
    sticky.el = el;
    var priceEl = el.querySelector('[data-btto-sticky-price]');
    var btn = el.querySelector('[data-btto-sticky-btn]');
    var footers = Array.prototype.slice.call(doc.querySelectorAll('.shopify-section-group-footer-group, footer'));
    var mainVisible = true, footerVisible = false, purchasable = !mainBtn.classList.contains('disabled');
    function footerInView() { var vh = window.innerHeight; return footers.some(function (f) { var r = f.getBoundingClientRect(); return r.height > 0 && r.top < vh - 20 && r.bottom > 0; }); }
    function render() { el.classList.toggle('is-visible', purchasable && !mainVisible && !footerInView() && mainBtn.getBoundingClientRect().bottom < 0); }
    sticky.update = function (v) { purchasable = v.available; if (priceEl) priceEl.textContent = money(v.price); render(); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { mainVisible = en[0].isIntersecting; render(); }).observe(mainBtn);
    }
    window.addEventListener('scroll', render, { passive: true });
    btn.addEventListener('click', function () {
      var p = productJson();
      if (p && p.variants.length > 1) { mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      mainBtn.click();
    });
  }

  /* ---------- Recommendations: sold-out alternatives + similar + complementary ---------- */
  function card(p) {
    var img = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=360') : '';
    return '<a class="btto-recs__card" href="' + p.url + '">' + (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') + '<span class="btto-recs__title">' + p.title + '</span><span class="btto-recs__price">' + money(p.price) + '</span></a>';
  }
  function recs() {
    var wrap = doc.querySelector('[data-btto-recs]');
    if (!wrap) return;
    var id = wrap.dataset.productId, base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function get(intent, limit) {
      return fetch(base + 'recommendations/products.json?product_id=' + id + '&limit=' + limit + '&intent=' + intent)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return (j.products || []).filter(function (p) { return p.available && String(p.id) !== String(id); }); })
        .catch(function () { return []; });
    }
    var myType = (wrap.dataset.productType || '').toLowerCase(), myPrice = parseInt(wrap.dataset.productPrice, 10) || 0;
    get('related', 10).then(function (list) {
      var same = list.filter(function (p) { return (p.type || '').toLowerCase() === myType; })
        .sort(function (a, b) { return Math.abs(a.price - myPrice) - Math.abs(b.price - myPrice); });
      var others = list.filter(function (p) { return same.indexOf(p) === -1; });
      list = same.concat(others);
      var alts = doc.querySelector('[data-btto-alts]');
      if (alts && same.length) {
        alts.querySelector('ul').innerHTML = same.slice(0, 3).map(function (p) {
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          return '<li><a href="' + p.url + '"><img loading="lazy" src="' + img + '" alt=""><span>' + p.title + '</span><span class="btto-alts__price">' + money(p.price) + '</span></a></li>';
        }).join('');
        alts.hidden = false;
      }
      var sim = wrap.querySelector('[data-btto-similar]');
      if (sim && list.length >= 2) { sim.querySelector('.btto-recs__grid').innerHTML = list.slice(0, 4).map(card).join(''); sim.hidden = false; }
    });
    get('complementary', 8).then(function (list) {
      var comp = wrap.querySelector('[data-btto-complementary]');
      if (comp && list.length >= 2) { comp.querySelector('.btto-recs__grid').innerHTML = list.slice(0, 4).map(card).join(''); comp.hidden = false; }
    });
  }

  function init() {
    setHeaderVar(); addSearchToggle(); syncSections(); bindSectionLinks(); finance(); reviews();
    delivery(null); bindVariants(); stepper(); initSticky(); recs();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setHeaderVar);
    (mqDesktop.addEventListener ? mqDesktop.addEventListener('change', syncSections) : mqDesktop.addListener(syncSections));
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();

/* Quantity stepper */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-btto-qty-step]');
    if (!b) return;
    var wrap = b.closest('[data-btto-qty]'); var input = wrap && wrap.querySelector('input');
    if (!input || input.disabled) return;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || Infinity;
    var v = (parseInt(input.value, 10) || min) + parseInt(b.dataset.bttoQtyStep, 10);
    input.value = Math.max(min, Math.min(max, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.btto-qty__input')) return;
    var v = parseInt(e.target.value, 10);
    if (!v || v < 1) e.target.value = 1;
  });
})();
